import { FullLink as a } from "./index6.js";
import "@ado/acs-standard-library";
import "@ado/tracking-library";
import { TRACKING_EVENTS as t } from "../../../shared/data/tracking/types/index.js";
import { FooterLinks as s } from "./index2.js";
import { createLegalDocumentsLink as C } from "./index7.js";
function k(e, l = "US") {
  let n = [];
  const r = e.sitebrand === void 0 ? "" : e.sitebrand.toLowerCase() ?? "", o = u(e, l, r);
  switch (r) {
    case "rechtsdokumente":
      n = O(o);
      break;
    case "documentsl\xE9gaux":
      n = g(o);
      break;
    case "doculaw":
      n = c(o);
      break;
    default:
      n = c(o);
      break;
  }
  return n;
}
const u = function(e, l, n) {
  const r = new s();
  return r.resourcesPage.setIsVisible(e.showLawLibrary), r.contactPage.update(!0, e.contactPage), r.helpCenterPage.update(!0, e.contactPage), r.aboutPage.update(
    e.showAboutUs,
    e.aboutUsURL
  ), r.homePage.setIsVisible(e.showHomepage), r.affiliatePage.update(
    e.showAffiliate,
    e.affiliateURL
  ), r.whiteLabelPage.setIsVisible(e.showWhiteLabel), r.careersPage.setIsVisible(e.showCareers), r.legalDocumentsPage = C(
    l,
    e
  ), r.lawLibraryPage.update(
    e.showLawLibrary,
    "/resources/"
  ), (n === "rechtsdokumente" || n === "documentsl\xE9gaux") && (r.cancelPage.update(
    e.showCancelPageLink,
    e.cancelUrl
  ), r.legalNoticePage.update(!0, e.legalNoticeURL), r.termsPage.update(!0, e.termsURL), r.privacyPage.update(!0, e.privacyPolicy), r.cookiePage.update(!0, e.cookiesPolicyURL)), r;
}, i = function(e) {
  return e.filter((l) => l.isVisible);
}, g = function(e) {
  let l = [], n = [];
  return l = [
    new a(e.homePage, "footer-links.home").addTracking(
      t.FOOTER_HOME_CLICK
    ),
    new a(
      e.termsPage,
      "footer.terms-of-use-title"
    ).addTracking(t.FOOTER_TERMS_OF_USE_CLICK),
    new a(e.helpCenterPage, "help-center", !0).addTracking(
      t.FOOTER_HELP_CENTER_CLICK
    ),
    new a(e.cookiePage, "footer.cookie-policy").addTracking(
      t.FOOTER_COOKIE_POLICY_CLICK
    )
  ], n = [
    new a(e.aboutPage, "footer-links.about").addTracking(
      t.FOOTER_ABOUT_CLICK
    ),
    new a(e.privacyPage, "footer.privacy-policy").addTracking(
      t.FOOTER_PRIVACY_POLICY_CLICK
    ),
    new a(
      e.legalDocumentsPage,
      "footer-links.legal-documents"
    ),
    new a(
      e.legalNoticePage,
      "footer-links.legal-notice"
    ).addTracking(t.FOOTER_LEGAL_NOTICE_CLICK)
  ], [l, n];
}, O = function(e) {
  let l = [], n = [];
  return l = [
    new a(e.homePage, "footer-links.home").addTracking(
      t.FOOTER_HOME_CLICK
    ),
    new a(e.aboutPage, "footer-links.about").addTracking(
      t.FOOTER_ABOUT_CLICK
    ),
    new a(
      e.legalDocumentsPage,
      "footer-links.legal-documents"
    ).addTracking(t.FOOTER_LEGAL_DOCUMENTS_CLICK),
    new a(
      e.cancelPage,
      "footer-links.cancel-page"
    ).addTracking(t.FOOTER_CANCEL_PAGE_CLICK)
  ], n = [
    new a(
      e.legalNoticePage,
      "footer-links.legal-notice"
    ).addTracking(t.FOOTER_LEGAL_NOTICE_CLICK),
    new a(
      e.termsPage,
      "footer.terms-of-use-title"
    ).addTracking(t.FOOTER_TERMS_OF_USE_CLICK),
    new a(e.privacyPage, "footer.privacy-policy").addTracking(
      t.FOOTER_PRIVACY_POLICY_CLICK
    ),
    new a(e.cookiePage, "footer.cookie-policy").addTracking(
      t.FOOTER_COOKIE_POLICY_CLICK
    ),
    new a(e.helpCenterPage, "help-center", !0).addTracking(
      t.FOOTER_HELP_CENTER_CLICK
    )
  ], [l, n];
}, c = function(e) {
  let l = [], n = [];
  return l = [
    new a(e.homePage, "footer-links.home").addTracking(
      t.FOOTER_HOME_CLICK
    ),
    new a(e.aboutPage, "footer-links.about").addTracking(
      t.FOOTER_ABOUT_CLICK
    ),
    new a(e.contactPage, "footer-links.contact", !0),
    new a(e.helpCenterPage, "help-center", !0).addTracking(
      t.FOOTER_HELP_CENTER_CLICK
    ),
    new a(
      e.businessSolutionPage,
      "footer-links.business-solutions",
      !0
    ).addTracking(t.FOOTER_BUSINESS_SOLUTIONS_CLICK)
  ], n = [
    new a(
      e.legalDocumentsPage,
      "footer-links.legal-documents"
    ).addTracking(t.FOOTER_LEGAL_DOCUMENTS_CLICK),
    new a(
      e.resourcesPage,
      "footer-links.resources"
    ).addTracking(t.FOOTER_RESOURCES_CLICK),
    new a(
      e.affiliatePage,
      "footer-links.affilicate-program"
    ).addTracking(t.FOOTER_AFFILIATE_PROGRAM_CLICK),
    new a(
      e.whiteLabelPage,
      "footer-links.white-label-program"
    ).addTracking(t.FOOTER_WHITE_LABEL_PROGRAM_CLICK),
    new a(e.careersPage, "footer-links.careers")
  ], [
    i(l),
    i(n)
  ];
};
export {
  k as generateColumnLinks
};
//# sourceMappingURL=index5.js.map
